export default function Forward() {
  return (
    <svg width="7" height="12" viewBox="0 0 7 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M4.27264 5.99997L0.451637 9.82097C0.0376368 10.235 0.0376368 10.907 0.451637 11.321C0.865637 11.735 1.53764 11.735 1.95164 11.321L6.56564 6.70697C6.95664 6.31597 6.95664 5.68297 6.56564 5.29297L1.95164 0.678969C1.53764 0.26497 0.865637 0.26497 0.451637 0.678969C0.0376368 1.09297 0.0376368 1.76497 0.451637 2.17897L4.27264 5.99997Z" fill="currentColor"/>
    </svg>
  )
}
